import React, { useEffect, useState } from 'react'
import { getApi } from '../../../utils/services';
import { AP_AGING, FINANCIAL_YEAR_LIST, PAYMENT_LIST_API, PENDING_REPORTS } from '../../../utils/apiRoutes';
import { useFeedPayment } from '../../../utils/helpers/tableHelpers/useFeedPayment';
import { PAYMENT_PENDING } from '../../../utils/constant';
import PieChart from '../../charts/piechart/PieChart';
import { Helmet } from "react-helmet";
import Loader from '../../common/Loader';
import GroupedBarChart from '../../charts/barchart/GroupedBarChart';
import Payment from '../../Table/Payment';

const SuperAdminDashboard = () => {
    const [paymentList, setPaymentList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [reportsPieChart, setReportsPieChart] = useState();
    const [totalAmount, setTotalAmount] = useState([]);
    const [agingBuckets, setAgingBuckets] = useState([]);
    const [label, setLabel] = useState();
    // const [selectedRows, setSelectedRows] = useState([]);

    //------------------------------pagination-------------------
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [globalSearch, setGlobalSearch] = useState("");
    const [financialYearList, setFinancialYearList] = useState([])
    const [currentFinancialYearId, setCurrentFinancialYearId] = useState('')
    const pageSize = 5;

    useEffect(() => {
        handlerReportsPieChart();
        handleFinancialYearList()
    }, []);

    useEffect(() => {
        handlerPayList(pageNumber, pageSize, globalSearch);
    }, [pageNumber]);

    const handleFinancialYearList = async () => {
        try {
            setLoader(true)
            let result = await getApi(FINANCIAL_YEAR_LIST)
            setFinancialYearList(result.res.financialYear_list)
            setLoader(false)

            if (result.res.financialYear_list.length > 0) {
                const currentYear = result.res.financialYear_list[result.res.financialYear_list.length - 1];
                setCurrentFinancialYearId(currentYear.id);
                handlerApAging(currentYear.id);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const handlerPayList = async (pageNumber, pageSize, globalSearch) => {
        try {
            setLoader(true)
            let result = await getApi(`${PAYMENT_LIST_API}?page=${pageNumber}&pageSize=${pageSize}&globalSearch=${globalSearch}&status=${PAYMENT_PENDING}`);
            setLoader(false)
            setPaymentList(result.res.payment_list)
            const totalItems = result.res.record_count;
            setTotalPages(Math.ceil(totalItems / pageSize));
        } catch (error) {
            setLoader(false)
        }
    }

    // const handleRowSelection = (selectedRows) => {
    //     setSelectedRows(selectedRows);
    // };

    const handlerReportsPieChart = async () => {
        try {
            setLoader(true)
            let result = await getApi(PENDING_REPORTS);
            let data = result.res.series;
            let label = result.res.labels;
            setLoader(false)
            setReportsPieChart(data)
            setLabel(label)
        } catch (error) {
            console.log(error);
        }
    }

    const handlerApAging = async (currentFinancialYearId) => {
        try {
            setLoader(true)
            let result = await getApi(`${AP_AGING}?currentFinancialYearId=${currentFinancialYearId}`);
            const { agingBuckets, totalAmount } = result.res
            let seriesData = [{
                name: 'Aging',
                data: totalAmount
            }];
            setLoader(false)
            setTotalAmount(seriesData)
            setAgingBuckets(agingBuckets)
        } catch (error) {
            console.log(error);
        }
    }

    const paymentColumn = useFeedPayment(handlerPayList, pageNumber, pageSize, globalSearch);

    const handlePageChange = (page) => {
        setPageNumber(page);
    };

    return (
        <>
            <Helmet>
                <title>Vendor Portal || Home</title>
            </Helmet>
            <Loader isLoading={loader} />
            <>
                <div className="row">
                    <div class="col-lg-8 col-md-7 mb-2">
                    </div>
                    <div class="col-lg-4 col-md-5 mb-2">
                        <label htmlFor="financialYear" className="form-label">Financial Year</label>
                        <select
                            id="financialYear"
                            className="form-select"
                            name="financialYear"
                            value={currentFinancialYearId}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setCurrentFinancialYearId(selectedId);
                                handlerApAging(selectedId);
                            }}>
                            {financialYearList.map((item, index) => (
                                <option key={index} value={item.id}>
                                    {item.CurrentFinancialYear}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='col-12 mb-2'>
                        <div className="row g-2">
                            <div className="col-12 col-lg-6">
                                <div className='container-section mb-0'>
                                    <div className="card-body  min-card-body-height">
                                        <h5>Approval Queue</h5>
                                        <PieChart
                                            // title='Approval Queue'
                                            data={reportsPieChart}
                                            label={label} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-6">
                                <div className='container-section mb-0'>
                                    <div className="card-body  min-card-body-height">
                                        <h5>AP Aging</h5>
                                        <GroupedBarChart
                                            // title='AP Aging'
                                            categories={agingBuckets}
                                            data={totalAmount}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="container-section mb-0">
                            <div className="section-header">
                                <h3>Pending Payment</h3>
                            </div>
                            <div className="card-body">
                                <Payment
                                    columns={paymentColumn}
                                    data={paymentList}
                                    // handleRowSelection={handleRowSelection}
                                    pageNumber={pageNumber}
                                    setPageNumber={setPageNumber}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                    globalSearch={globalSearch}
                                    setGlobalSearch={setGlobalSearch}
                                    pageSize={pageSize}
                                    handlerPayList={handlerPayList} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    )
}

export default SuperAdminDashboard